import { render } from "./error-alert.vue?vue&type=template&id=4de0a734"
import script from "./error-alert.vue?vue&type=script&lang=js"
export * from "./error-alert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__